<div class="flex flex-col gap-4 p-4">
    <!-- Stats Summary -->
    <div class="grid grid-cols-2 gap-3" [ngClass]="isBimestrale ? 'md:grid-cols-3' : 'md:grid-cols-5'">
        <div class="bg-neutral-100 rounded-[12px] p-3 text-center">
            <p class="text-xs text-neutral-500 uppercase">{{ 'admin.qa.energy_type' | transloco }}</p>
            <p class="text-lg font-bold">{{ qaData?.stats?.energy_type || '-' }}</p>
        </div>
        <div class="bg-neutral-100 rounded-[12px] p-3 text-center">
            <p class="text-xs text-neutral-500 uppercase">{{ 'admin.qa.total_fields' | transloco }}</p>
            <p class="text-lg font-bold">{{ totalFields }}</p>
        </div>
        <div *ngIf="!isBimestrale" class="bg-neutral-100 rounded-[12px] p-3 text-center">
            <p class="text-xs text-neutral-500 uppercase">{{ 'admin.qa.v1_extracted' | transloco }}</p>
            <p class="text-lg font-bold"
                [ngClass]="getExtractedClass(qaData?.stats?.extracted_fields_old || 0, qaData?.stats?.extracted_fields_new || 0)">
                {{ qaData?.stats?.extracted_fields_old }}/{{ totalFields }}
                ({{ qaData?.stats?.accuracy_old | number:'1.1-1' }}%)
            </p>
        </div>
        <div class="bg-neutral-100 rounded-[12px] p-3 text-center">
            <p class="text-xs text-neutral-500 uppercase">{{ 'admin.qa.v2_extracted' | transloco }}</p>
            <p class="text-lg font-bold"
                [ngClass]="isBimestrale ? '' : getExtractedClass(qaData?.stats?.extracted_fields_new || 0, qaData?.stats?.extracted_fields_old || 0)">
                {{ qaData?.stats?.extracted_fields_new }}/{{ totalFields }}
                ({{ qaData?.stats?.accuracy_new | number:'1.1-1' }}%)
            </p>
        </div>
        <div *ngIf="!isBimestrale" class="rounded-[12px] p-3 text-center"
            [ngClass]="improvementDiff >= 0 ? 'bg-success-100' : 'bg-error-100'">
            <p class="text-xs text-neutral-500 uppercase">{{ 'admin.qa.improvement' | transloco }}</p>
            <p class="text-lg font-bold" [ngClass]="improvementDiff >= 0 ? 'text-success-500' : 'text-error-500'">
                {{ improvementDiff >= 0 ? '+' : '' }}{{ improvementDiff }} {{ 'admin.qa.fields' | transloco }}
            </p>
            <p class="text-xs text-neutral-400">
                ({{ qaData?.stats?.accuracy_old | number:'1.1-1' }}% -> {{ qaData?.stats?.accuracy_new | number:'1.1-1'
                }}%)
            </p>
        </div>
    </div>

    <!-- AI Tools Panel -->
    <app-qa-ai-tools-panel
        [qaData]="qaData"
        [toast]="toast"
        [erikRecord]="erikRecord"
        [neoxRecord]="neoxRecord"
        [updatedRecord]="updatedRecord"
        [filteredComparisons]="filteredComparisons"
        [invoicePeriodType]="invoicePeriodType">
    </app-qa-ai-tools-panel>

    <!-- Table Filter -->
    <div class="flex items-center gap-3">
        <div class="w-[250px]">
            <app-custom-dropdown
                [options]="filterDropdownOptions"
                [(selectedOption)]="selectedFilterIndex"
                label="{{ 'admin.qa.filter_mismatches' | transloco }}">
            </app-custom-dropdown>
        </div>
    </div>

    <!-- Field Comparison Table -->
    <div class="overflow-x-auto rounded-[12px] border border-neutral-200">
        <table class="table w-full">
            <thead class="bg-neutral-100 text-neutral-700 uppercase">
                <tr>
                    <th class="border-b border-border px-4 py-3 font-normal">{{ 'admin.qa.field' | transloco }}</th>
                    <th *ngIf="!isBimestrale" class="border-b border-border px-4 py-3 font-normal">V1</th>
                    <th class="border-b border-border px-4 py-3 font-normal">V2</th>
                    <th class="border-b border-border px-4 py-3 font-normal">{{ 'admin.qa.updated_value' | transloco
                        }}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of displayRows">
                    <!-- Period separator row -->
                    <tr *ngIf="row.type === 'separator'" class="bg-primary-100">
                        <td [attr.colspan]="isBimestrale ? 3 : 4"
                            class="border-b border-border px-4 py-3 font-semibold text-sm text-primary">
                            {{ row.periodLabel }}
                        </td>
                    </tr>
                    <!-- Comparison row -->
                    <tr *ngIf="row.type === 'comparison'"
                        [ngClass]="(!row.comparison!.neoxMatch || (!isBimestrale && !row.comparison!.erikMatch)) ? 'bg-warning-50' : ''">
                        <td class="border-b border-border px-4 py-2 font-medium text-sm" [title]="row.comparison!.field">{{ translateField(row.comparison!.field) }}</td>
                        <td *ngIf="!isBimestrale" class="border-b border-border px-4 py-2 text-sm">
                            <span [ngClass]="getMatchClass(row.comparison!.erikMatch)">{{ formatValue(row.comparison!.erik) }}</span>
                        </td>
                        <td class="border-b border-border px-4 py-2 text-sm">
                            <span [ngClass]="getMatchClass(row.comparison!.neoxMatch)">{{ formatValue(row.comparison!.neox) }}</span>
                        </td>
                        <td class="border-b border-border px-4 py-2 text-sm font-medium">{{ formatValue(row.comparison!.updated) }}
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <!-- No Data Message -->
    <div *ngIf="!updatedRecord" class="text-center text-neutral-400 py-4">
        {{ 'admin.qa.no_updated_record' | transloco }}
    </div>
</div>
